<div class="detail">
  <span class="label">{{label}}</span>
  <span class="value">{{value}}</span>
</div>
